import QRcode from 'qrcode.react';
import React from 'react';
import './index.less';

const pathname = window.location.href;

export const QrCodeType = {
    '新创建二维码': 'NEW',
    '已扫码': 'SCAN',
    '用户授权成功': 'SUCCESS',
    '过期': 'EXPIRE',
}

const QrCodeDesc = {
    'NEW': '打开微信扫描二维码授权登录',
    'SCAN': pathname.includes('/login') ? '请在手机上点击确定以登录' : '请在手机上点击确定以绑定',
    'SUCCESS': '授权成功，页面正在跳转',
    'EXPIRE': '二维码已失效，请点击刷新',
}

const WechatQrcode = ({qrCodeUrl, qrCodeStatus = QrCodeType.新创建二维码, refreshQrCode}) => {

    return (
        <div className="wechat-qrcode">
            <div className="qrcode-wrapper">
                <QRcode className="qrcode" value={qrCodeUrl} size={160} level={'M'}/>
                {
                    qrCodeStatus !== QrCodeType.新创建二维码 && (
                        <div className="mask">
                            <div className={`status ${qrCodeStatus === QrCodeType.过期 ? 'refresh' : ''}`}>
                                {
                                    qrCodeStatus === QrCodeType.过期 ?
                                        <img
                                            onClick={refreshQrCode}
                                            src={require('@/assets/images/account-safety/refresh-black.png')}
                                        /> :
                                        qrCodeStatus === QrCodeType.已扫码
                                            ? <img src={require('@/assets/images/account-safety/success-black.png')} />
                                            : null
                                }
                                <p>{qrCodeStatus === QrCodeType.过期 ? '刷新' : qrCodeStatus === QrCodeType.已扫码 ? '已扫描' : ''}</p>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="description">
                <img src={require('@/assets/images/account-safety/scan.png')} alt=""/>
                <span>{QrCodeDesc[qrCodeStatus]}</span>
            </div>
        </div>
    )
}

export default WechatQrcode;
